/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalCoverageDetail } from './AdditionalCoverageDetail';
import {
    AdditionalCoverageDetailFromJSON,
    AdditionalCoverageDetailFromJSONTyped,
    AdditionalCoverageDetailToJSON,
    AdditionalCoverageDetailToJSONTyped,
} from './AdditionalCoverageDetail';
import type { StructuredAnalysisResponseDataCoverageAmounts } from './StructuredAnalysisResponseDataCoverageAmounts';
import {
    StructuredAnalysisResponseDataCoverageAmountsFromJSON,
    StructuredAnalysisResponseDataCoverageAmountsFromJSONTyped,
    StructuredAnalysisResponseDataCoverageAmountsToJSON,
    StructuredAnalysisResponseDataCoverageAmountsToJSONTyped,
} from './StructuredAnalysisResponseDataCoverageAmounts';
import type { StructuredAnalysisResponseDataCoverageStatus } from './StructuredAnalysisResponseDataCoverageStatus';
import {
    StructuredAnalysisResponseDataCoverageStatusFromJSON,
    StructuredAnalysisResponseDataCoverageStatusFromJSONTyped,
    StructuredAnalysisResponseDataCoverageStatusToJSON,
    StructuredAnalysisResponseDataCoverageStatusToJSONTyped,
} from './StructuredAnalysisResponseDataCoverageStatus';
import type { ValueWithNote } from './ValueWithNote';
import {
    ValueWithNoteFromJSON,
    ValueWithNoteFromJSONTyped,
    ValueWithNoteToJSON,
    ValueWithNoteToJSONTyped,
} from './ValueWithNote';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponseData
 */
export interface StructuredAnalysisResponseData {
    /**
     * 
     */
    coverage_status?: StructuredAnalysisResponseDataCoverageStatus;
    /**
     * 
     */
    coverage_amounts?: StructuredAnalysisResponseDataCoverageAmounts;
    /**
     * 
     */
    snf_benefit_days_used?: ValueWithNote;
    /**
     * 
     */
    snf_benefit_days_total?: ValueWithNote;
    /**
     * 
     */
    snf_benefit_days_remaining?: ValueWithNote;
    /**
     * 
     */
    additional_coverage_details?: Array<AdditionalCoverageDetail>;
    /**
     * 
     */
    snf_benefit_days?: ValueWithNote;
    /**
     * Phone number to retry the call with
     */
    internal_redirect_number?: string;
}

/**
 * Check if a given object implements the StructuredAnalysisResponseData interface.
 */
export function instanceOfStructuredAnalysisResponseData(value: object): value is StructuredAnalysisResponseData {
    return true;
}

export function StructuredAnalysisResponseDataFromJSON(json: any): StructuredAnalysisResponseData {
    return StructuredAnalysisResponseDataFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage_status': json['coverage_status'] == null ? undefined : StructuredAnalysisResponseDataCoverageStatusFromJSON(json['coverage_status']),
        'coverage_amounts': json['coverage_amounts'] == null ? undefined : StructuredAnalysisResponseDataCoverageAmountsFromJSON(json['coverage_amounts']),
        'snf_benefit_days_used': json['snf_benefit_days_used'] == null ? undefined : ValueWithNoteFromJSON(json['snf_benefit_days_used']),
        'snf_benefit_days_total': json['snf_benefit_days_total'] == null ? undefined : ValueWithNoteFromJSON(json['snf_benefit_days_total']),
        'snf_benefit_days_remaining': json['snf_benefit_days_remaining'] == null ? undefined : ValueWithNoteFromJSON(json['snf_benefit_days_remaining']),
        'additional_coverage_details': json['additional_coverage_details'] == null ? undefined : ((json['additional_coverage_details'] as Array<any>).map(AdditionalCoverageDetailFromJSON)),
        'snf_benefit_days': json['snf_benefit_days'] == null ? undefined : ValueWithNoteFromJSON(json['snf_benefit_days']),
        'internal_redirect_number': json['internal_redirect_number'] == null ? undefined : json['internal_redirect_number'],
    };
}

export function StructuredAnalysisResponseDataToJSON(json: any): StructuredAnalysisResponseData {
    return StructuredAnalysisResponseDataToJSONTyped(json, false);
}

export function StructuredAnalysisResponseDataToJSONTyped(value?: StructuredAnalysisResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coverage_status': StructuredAnalysisResponseDataCoverageStatusToJSON(value['coverage_status']),
        'coverage_amounts': StructuredAnalysisResponseDataCoverageAmountsToJSON(value['coverage_amounts']),
        'snf_benefit_days_used': ValueWithNoteToJSON(value['snf_benefit_days_used']),
        'snf_benefit_days_total': ValueWithNoteToJSON(value['snf_benefit_days_total']),
        'snf_benefit_days_remaining': ValueWithNoteToJSON(value['snf_benefit_days_remaining']),
        'additional_coverage_details': value['additional_coverage_details'] == null ? undefined : ((value['additional_coverage_details'] as Array<any>).map(AdditionalCoverageDetailToJSON)),
        'snf_benefit_days': ValueWithNoteToJSON(value['snf_benefit_days']),
        'internal_redirect_number': value['internal_redirect_number'],
    };
}

